import { View } from 'react-native'
import ModalWide from '@ui/components/Modal/variants/ModalWide'
import { useStagesStore } from 'hooks/useStagesStore'
import {
  SummaryModalBody,
  useCurrentSummaryModal,
} from '@order/modals/Summary/SummaryModal'
import FrameDetails from '@frame/FrameDetails'

export default function TopbarModal() {
  const isModal = useStagesStore((state) => state.isModal)
  const setIsModal = useStagesStore((state) => state.setIsModal)

  const summaryProps = useCurrentSummaryModal()

  const close = () => {
    setIsModal(false)
  }

  return (
    <ModalWide open={isModal} close={close} hideBottomSpace>
      <View className="flex flex-col gap-8 p-8">
        <FrameDetails />
        <SummaryModalBody {...summaryProps} withHeader={false} />
      </View>
    </ModalWide>
  )
}
